export default $wire => ({
    definitionOpen: $wire.entangle('definitionOpen').live,
    openMarketTrend($dispatch) {
        $dispatch('open-market-trend');
    },
    init() {
        $wire.load();
    },
});
